import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type AppRouterProps = {
  children: React.ReactNode;
};

export function AppRouter(props: AppRouterProps) {
  const { children } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = useRef(location.pathname);

  const [initialPathChecked, setInitialPathChecked] = useState(false);

  useEffect(() => {
    let loc = location.pathname;
    currentPath.current = loc;

    if (window.AP && initialPathChecked) {
      if (location.search) {
        loc += location.search;
      }
      const jiraState = window.AP.history.getState();
      if (loc !== jiraState) {
        window.AP.history.pushState(loc);
      }
    }
  }, [location, initialPathChecked]);

  useEffect(() => {
    if (window.AP?.getLocation) {
      window.AP.getLocation((location: string) => {
        if (location) {
          const locParts = location.split('#!');
          if (locParts.length > 1) {
            navigate(locParts[1]);
          }
          setInitialPathChecked(true);
        }
      });
      // This will listen instance hash change event and open the page accordingly
      window.AP.history.popState((e) => {
        if (e && e.newURL && e.newURL != currentPath.current) {
          navigate(e.newURL);
        }
      });
    }
  }, []);

  return <>{children}</>;
}
